import { t as __t } from "i18next";
import React, { useState, useEffect } from "react";
import { useListRefreshListener } from "../../../utils/listNavigation";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { callGetGrandUserPerssion, callDeleteGrandUserPerssion } from "../../../api/settings/service";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { encodeBase64, handleGetCookie } from "../../../utils/commonUtil"
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import RecordsTableFilter from "../../../components/table-filter"
import "../../../components/i18n/lang";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../components/paginations";
import Swal from "sweetalert2";
// import { callExportShop } from "../../../api/export";
import moment from "moment";
import colors from '../../../utils/colors'
import SmartTable from "../../../components/common/table-component";

const Index = () => {
	let baseUrl = "/admin/setting/userPermission/save";
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [request, setRequest] = useState({ page: 1, maxResult: 10, keyword: '', carriredCode: '', carriredName: '' });
	const [userList, setUserList] = useState([]);
	const [totalPages, setTotalPages] = useState(1);
	const [totalRecord, setTotalRecord] = useState(1);

	useEffect(() => {
		loadData();

		const authData = handleGetCookie('auth');
		if (authData?.user?.userId) {
			setRequest((prev) => ({
				...prev,
				carriredCode: authData?.user?.userId,
				carriredName: authData?.user?.firstName + " " + authData?.user?.lastName,
			}));
		}
	}, [request.page, request.maxResult]);

	const loadData = async () => {
		let data = { keyword: request.keyword, page: request.page, maxResult: request.maxResult };
		const rsp = await dispatch(callGetGrandUserPerssion(data));
		if (rsp?.payload?.responseCode === "00000") {
			setUserList(rsp.payload.data.result);
			setTotalPages(rsp.payload.data.totalPages);
			setTotalRecord(rsp.payload.data.totalRecords)
		}
	};

	const handlePageChange = (pageNumber) => {
		if (pageNumber >= 1 && pageNumber <= totalPages) {
			setRequest((prev) => ({ ...prev, page: pageNumber }));
		}
	};

	const handleChange = (e) => {
		setRequest((prev) => ({ ...prev, keyword: e.target.value }));
	};

	const onSearch = async (e) => {
		e.preventDefault()
		loadData();
	}

	const handleEdit = (id) => {
		navigate(baseUrl + "/" + encodeBase64(id))
	}

	const handleDelete = (userId) => {
		Swal.fire({
			title: t("titleDelete"),
			text: t("confirmDelete"),
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: colors.confirmMessage,
			cancelButtonColor: colors.cancel,
			confirmButtonText: t('confirm'),
			cancelButtonText: t('cancel')
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					const rsp = await dispatch(callDeleteGrandUserPerssion({ userId, carriredCode: request.carriredCode, carriredName: request.carriredName }));
					if (rsp?.payload?.responseCode === "00000") {
						Swal.fire({
							icon: "success",
							title: t("success.delete"),
							confirmButtonColor: colors.confirmMessage,
							confirmButtonText: t('close'),
						}).then(() => {
							loadData();
						});
					}
				} catch (error) {
					Swal.fire(__t("uiText.text023"), __t("uiText.text024"), "error");
				}
			}
		});
	}

	const downloadExcel = async () => {
		// try {
		// 	let response = await callExportShop();
		// 	if (response === null) {
		// 		Swal.fire("ເກີດຄວາມຜິດພາດ!", "ດາວໂຫລດຂໍ້ມູນ excel ບໍ່ໄດ້", "error");
		// 		return
		// 	}
		// 	const url = URL.createObjectURL(response);
		// 	const link = document.createElement("a");
		// 	link.href = url;
		// 	link.download = `shops_${moment().format("YYYYMMDDHHmmss")}.xlsx`;
		// 	document.body.appendChild(link);
		// 	link.click();
		// 	document.body.removeChild(link);
		// } catch (error) {
		// 	console.error("❌ Error downloading Excel:", error);
		// }
	};

	useListRefreshListener(loadData);

	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box">
						<h4>{t("menu.setting.roleUser")}</h4>

						<div className="group-button-header d-flex gap-2">
							<button type="button" className="btn btn-outline-primary" onClick={() => navigate("/admin/setting/userPermission/webMenu")}>
								<i className="fas fa-sitemap"></i> {t("menu.setting.webMenu")}
							</button>
							<button type="button" className="btn btn-primary" onClick={() => navigate(baseUrl)}>
								<i className="fas fa-plus"></i> {t("button.add")}
							</button>
						</div>
					</div>

					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">
										<div className="row">
											<div className="col-md-3">
												<div className="form-group">
													<label>{t('search.keyword')}</label>
													<input
														type="text"
														name="keyword"
														className="form-control-uld"
														placeholder={t('search.keyword') + "..."}
														onChange={handleChange}
														value={request.keyword}
														autoComplete="off"
														required />
												</div>
											</div>
											<div className="col-auto auto-button">
												<label>&nbsp;</label>
												<button className="theme-btn btn-style-one w-100" onClick={onSearch}>
													<i className="fas fa-search"></i>&nbsp;{t("button.search")}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div className="row">
						<div className="col-12">
							<div className="ls-widget">
								<div className="tabs-box">
									<div className="widget-content p-4">

										<RecordsTableFilter
											totalRecord={totalRecord}
											perPage={request.maxResult}
											onChange={(e) =>
												setRequest((prev) => ({
													...prev,
													maxResult: Number(e.target.value),
													page: 1,
												}))
											}
										/>

										<SmartTable
											columns={[
												{ labelKey: "user.id", key: "userId" },
												{ labelKey: "user.firstName", key: "firstName" },
												{ labelKey: "user.lastName", key: "lastName" },
												{ labelKey: "user.role", key: "roleCode", render: (val, row) => `${val || ''} ${row.status ?? ''}`.trim() || '-' },
												{ labelKey: "user.status", key: "status", render: (val) => val === 1 ? <span className="badge bg-success">{t('status.active')}</span> : <span className="badge bg-danger">{t('status.inActive')}</span> },
											]}
											data={{ result: userList }}
											rowKey="userId"
											recordsTableFilter={false}
											customPagination={false}
											showRowNumber={false}
											actions={(item) => (<div>
												<button className="btn btn-primary btn-sm" onClick={() => handleEdit(item.userId)}><i className="fas fa-pen"></i></button>
												&nbsp;
												<button className="btn btn-danger btn-sm" onClick={() => handleDelete(item.userId)}><i className="fas fa-trash"></i></button>
											</div>)}
										/>

										<CustomPagination
											currentPage={request.page}
											totalPages={totalPages}
											onPageChange={handlePageChange}
											maxVisiblePages={1}
										/>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
